import { render, staticRenderFns } from "./InvoiceApiColumns.vue?vue&type=template&id=2a842199&scoped=true"
import script from "./InvoiceApiColumns.vue?vue&type=script&lang=js"
export * from "./InvoiceApiColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a842199",
  null
  
)

export default component.exports